var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRotationFaceFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9912,
    cy: 10,
    r: 10,
    fill: "#769DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7404 7.5237H7.78161L9.96547 5.33984L8.64644 4.02081L4.85735 7.80991C4.49026 8.17699 4.49026 8.76807 4.85735 9.12893L8.61533 12.8869L9.93436 11.5679L7.7505 9.38403H12.7404C14.2834 9.38403 15.534 10.448 15.534 11.7483C15.534 13.0487 14.2772 14.1126 12.7404 14.1126H11.8071V15.9792H12.7404C15.31 15.9792 17.4005 14.0815 17.4005 11.7483C17.4005 9.41514 15.31 7.51748 12.7404 7.51748V7.5237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRotationFaceFill);
export default __webpack_public_path__ + "static/media/ic_rotation_face_fill.da7b19bdd500eb9b29a50f7781b57928.svg";
export { ForwardRef as ReactComponent };